import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../enum/app-routes.enum';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event) => {},
                (error) => {
                    if (error.status === 401) {
                        this.router.navigate([`/${APP_ROUTES.LOGIN}`]);
                    }
                },
            ),
        );
    }
}
